//                       __        __
//    __  ______  __  __/ /___  __/ /_  ___
//   / / / / __ \/ / / / __/ / / / __ \/ _ \
//  / /_/ / /_/ / /_/ / /_/ /_/ / /_/ /  __/
//  \__, /\____/\__,_/\__/\__,_/_.___/\___/
// /____/

/* globals YT */

import { app } from './app';

window.onPlayerReady = function (event) {
  // console.groupCollapsed( 'onPlayerReady' );
  // console.log( 'event: %o', event );
  // console.groupEnd();

  // set initial volume level
  event.target.setVolume(100);
};

// https://developers.google.com/youtube/iframe_api_reference#Playback_status
// window.onPlayerStateChange = function(event) {
//   // const id = app.youtube.getDataId( event );

//   // console.groupCollapsed( '{ onPlayerStateChange }' );
//   // console.log( 'event.data: %o', event.data );
//   // console.log( 'id: %o', id );
//   // console.groupEnd();

//   if (event.data === YT.PlayerState.PLAYING) {
//     // console.log( 'YouTube Stage Change: Playing' );
//     // stop all players excepts current player id
//     // app.youtube.stopPlayers( id );
//     // update playing state
//     // app.playersJSON[ id ].playing = 1;
//   } else if (event.data === YT.PlayerState.BUFFERING) {
//     // console.log( 'YouTube Stage Change: Buffering' );
//     // stopPlayers( id );
//     // players[ id ].playing = id;
//   } else if (event.data === YT.PlayerState.ENDED) {
//     // console.log( 'YouTube Stage Change: Ended' );
//     // update playing state
//     // app.youtube.stopVideo( id );
//     // players[ id ].playing = 0;
//   } else if (event.data === YT.PlayerState.PAUSED) {
//     // console.log( 'YouTube Stage Change: Paused' );
//   } else if (5 === event.data) {
//     // console.log( 'YouTube Stage Change: Cued' );
//   }
// };

window.onYouTubeIframeAPIReady = function () {
  console.log('{ onYouTubeIframeAPIReady }');

  setupVideoPlayers();
};

// ----------------------------------------------------------------------------
//
// Setup Video Players
//
// ----------------------------------------------------------------------------
const setupVideoPlayers = () => {
  console.log('{ setupVideoPlayers }');

  const videoSlides = $('[data-youtubeid]');
  // console.log( 'videoSlides: %o', videoSlides );

  $.each(videoSlides, (i, el) => {
    // setup player object
    app.youtubePlayers[$(el).attr('id')] = new YT.Player($(el).attr('id'), {
      height: '400',
      width: '600',
      videoId: $(el).data('youtubeid'),
      playerVars: {
        showinfo: 0,
        rel: 0
        // modestbranding: 1
      },
      events: {
        onReady: window.onPlayerReady,
        onStateChange: window.onPlayerStateChange
      }
    });
  });
};

// ----------------------------------------------------------------------------
//
// App functions
//
// ----------------------------------------------------------------------------
const setupYoutube = () => {
  console.log('{ setupYoutube }');

  if ('undefined' !== typeof YT) {
    if (YT.loaded) {
      setupVideoPlayers();
    }
  }
};

// ----------------------------------------------------------------------------
// Utility: Stop Players
// ----------------------------------------------------------------------------
const stopPlayers = () => {
  console.log('{ stopPlayers }');

  // loop through all players
  $.each(Object.keys(app.youtubePlayers), (i, el) => {
    // if playing then stop
    if (1 === app.youtubePlayers[el].getPlayerState()) {
      // console.log( 'stopping video' );
      app.youtubePlayers[el].pauseVideo();
    }
  });
};

export { setupYoutube, stopPlayers };



// WEBPACK FOOTER //
// ./scripts/modules/youtube.js